import {createSignal, on, onMount, Show} from 'solid-js'
import {authenticate, getAdminUserProfile, saveOauthData} from 'store-actions'
import {AuthorizationError} from '@openid/appauth'
import {useNavigate} from '@solidjs/router'
import {getDeviceData, Spinner, useConfig, useDispatch, useSelector} from '../../libs/foundation'
import {
    CareAgentAuthorizationHandler,
    CareAgentAuthorizationType,
    CareAgentAuthorizerOptions,
} from './CareAgentAuthorizationHandler'

export const CareAgentRedirect = () => {
    const {getConfig} = useConfig()
    const navigate = useNavigate()

    const authConfig: CareAgentAuthorizerOptions = {
        allowGuest: getConfig().allowGuest,
        agentClientId: getConfig().carePortal.agentClientId,
        clientSecret: getConfig().carePortal.ssoClientSecret,
        redirectUri: window.location.origin + '/agent',
        authorizationType: CareAgentAuthorizationType.REDIRECT,
        responseType: CareAgentAuthorizationType.TOKEN,
        grant_type: getConfig().grant_type,
        scope: getConfig().carePortal.OAuthParam.scope,
        authorityConfiguration: {
            authorization_endpoint: getConfig().carePortal.urls.adminAuthUrl + getConfig().OAuthParam.endpoint.auth,
            token_endpoint: getConfig().OAuthParam.endpoint.fullTokenUrl
                ? getConfig().OAuthParam.endpoint.fullTokenUrl
                : getConfig().carePortal.urls.adminAuthUrl + getConfig().OAuthParam.endpoint.token,
            revocation_endpoint: '',
            registration_endpoint: '',
        },
        extras: {
            ...getConfig().carePortal.OAuthParam.extras,
            'x-ulm-sso-clientId': getConfig().carePortal.ssoClientId,
        },
    }

    const _authzHandler = new CareAgentAuthorizationHandler(authConfig)

    const dispatch = useDispatch()

    const callProfile = () => {
        return dispatch(
            getAdminUserProfile({
                onSuccess: () => {
                    navigate(_authzHandler?.getCbRedirectUrl?.() || 'agent/search')
                },
                onError: () => {},
            })
        )
    }

    onMount(async () => {
        _authzHandler.onSuccessTokenResponse = async tokenResponse => {
            if (tokenResponse) {
                dispatch(
                    saveOauthData({
                        token: tokenResponse.accessToken,
                        refreshToken: tokenResponse.refreshToken ? tokenResponse.refreshToken : undefined,
                        expirationDate: tokenResponse.issuedAt + (tokenResponse?.expiresIn || 0),
                    })
                )

                dispatch(
                    authenticate({
                        oauthToken: tokenResponse.accessToken,
                        oauthTokenExpirationDate: tokenResponse.issuedAt + (tokenResponse?.expiresIn || 0),
                        oauthRefreshToken: tokenResponse.refreshToken ? tokenResponse.refreshToken : undefined,
                        deviceData: getDeviceData(),
                        needFetchProfile: false,
                    })
                )

                setTimeout(async () => {
                    await callProfile()
                }, 0)
            }
        }
        _authzHandler.onFailureTokenResponse = async (error: AuthorizationError | null) => {}

        _authzHandler.checkForAuthorizationResponse()
    })

    return (
        <div
            style={{
                background: 'var(--background-color)',
                display: 'flex',
                'justify-content': 'center',
                height: '100%',
                'align-items': 'center',
            }}
        >
            <Spinner />
        </div>
    )
}

export default CareAgentRedirect
